import { render, staticRenderFns } from "./BtnTranslation.vue?vue&type=template&id=32a23340&scoped=true&"
import script from "./BtnTranslation.vue?vue&type=script&lang=js&"
export * from "./BtnTranslation.vue?vue&type=script&lang=js&"
import style0 from "./BtnTranslation.vue?vue&type=style&index=0&id=32a23340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a23340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32a23340')) {
      api.createRecord('32a23340', component.options)
    } else {
      api.reload('32a23340', component.options)
    }
    module.hot.accept("./BtnTranslation.vue?vue&type=template&id=32a23340&scoped=true&", function () {
      api.rerender('32a23340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ExtendMenu/RoomTranslation/BtnTranslation.vue"
export default component.exports